import { Inject, Injectable, Optional } from '@angular/core';
import { APP_CONFIG, AppConfiguration } from '@app/infrastructure/auth/app-configuration';

@Injectable({
	providedIn: 'root',
})
export class ConfigFacadeService {
	constructor(@Inject(APP_CONFIG) @Optional() private appConfig: AppConfiguration) {
		if (window?.zestyHost) {
			window.zestyHost.tempConfig = this.appConfig;
		}
	}

	public get config(): AppConfiguration {
		return this.appConfig;
	}

	public get partnerPrefix(): string {
		return this.appConfig.partner.prefix;
	}

	public get partnerName(): string {
		return this.appConfig.partner.name;
	}

	public get partnerId(): string {
		return this.appConfig.partner.id;
	}
}
